angular.module("overlappingDetail.components", []).component("overlappingDetail", {
    templateUrl: "ng/components/overlappingDetail/overlappingDetail.view.html",
    bindings: {
        leasingData: "=",
        financialModel: "=",
        isMonitorPratiche: "<"
    },
    controllerAs: "overlappingDetailCtrl",
    controller: function OverlappingDetail(
        $workflowService,
        $modalService,
        FinancialModel,
        $timeout,
        $financialApiService,
        $configService
    ) {

        var self = this;

        self.$onInit = function () {
            self.reteVendita = parseInt($configService.getUser().reteVendita);
            self.supportModel = {
                loaderM5: [],
                loaderM6: [],
                isLoading: false
            }

            if (!self.isMonitorPratiche) {
                self.aggiornaSovrapposizioni();
            }
        }

        self.getFromHistory = function (idWf, index, viewIndex) {
            self.supportModel.loaderM5[index]= (viewIndex ==3);
            self.supportModel.loaderM6[index]= (viewIndex ==4);
            $workflowService.getFromHistory(idWf, viewIndex)
                .then(function (response) {
                    var metadata = JSON.parse(response.metadata);
                    self.currentModel = FinancialModel.build(metadata.dynamicInputPojo);
                    self.valueOfviewIndex= parseInt(response.viewIndex);
                    $timeout(function() {
                        $(".mCSB_draggerContainer").hide();
                        $('.financial-leasing__footer').css("z-index", "-1");
                        $modalService.openModal('overlapping-modal');
                    },500) 
                    
                    self.supportModel.loaderM5[index]  = false; 
                    self.supportModel.loaderM6[index]  = false; 
                })
                .catch(function (error) {
                    console.log(error);
                    self.supportModel.loaderM5[index]  = false; 
                    self.supportModel.loaderM6[index]  = false;
                })
        }

        self.dismissModal = function () { 
            $(".mCSB_draggerContainer").show();
            $('.financial-leasing__footer').css("z-index", "1");
            $modalService.closeModal('overlapping-modal');
            self.currentModel = undefined;
        }

        self.aggiornaSovrapposizioni = function () {
            self.supportModel.isLoading = true;

            
            $financialApiService.checkSovrapposizioni(FinancialModel.build(self.financialModel))
                .then(function (response) {
                    self.leasingData.preventivo.dettaglioDeroga.preventiviSovrapposizione = response.preventiviSovrapposizione
                    self.supportModel.isLoading = false;
                })
                .catch(function() {
                    self.supportModel.isLoading = false;
                })
        }
    }
});